import type { QuickComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import type { QuickComposeViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import type { CalendarEvent } from 'owa-calendar-types';
import EventScope from 'owa-service/lib/contract/EventScope';
import { createComposeFormId } from '../utils/createComposeFormId';
import { startQuickComposePerfDatapoint } from 'owa-calendar-compose-form-utils';
import { CalendarComponent } from 'owa-calendar-usage-instrumentation';
import { lazyModule, lazyShowQuickCompose } from 'owa-calendar-compose-form-store';

export async function openCalendarQuickCompose(
    anchor: HTMLDivElement | string, //sets the target point that the callout it anchored to
    entrySource: QuickComposeEntrySourceType,
    viewType: QuickComposeViewType,
    initialCalendarEvent?: Partial<CalendarEvent>,
    eventScope: EventScope = EventScope.Default
): Promise<string | null> {
    const formId = createComposeFormId();

    await startQuickComposePerfDatapoint(
        formId!,
        getComponentFromViewType(viewType),
        lazyModule.getIsLoaded() /* bundleAlreadyLoaded */,
        entrySource
    );

    await lazyShowQuickCompose.importAndExecute(
        formId,
        anchor,
        entrySource,
        viewType,
        initialCalendarEvent,
        eventScope
    );

    return formId;
}

function getComponentFromViewType(viewType: QuickComposeViewType) {
    return viewType == 'TimePanel'
        ? CalendarComponent.MyDayPanelCompose
        : CalendarComponent.CalendarQuickCompose;
}
